/* shopinza-pdp.js - gallery, option pills, bundle tiers and cart buttons for the Shopinza product page */
(function(){
  function group(num,dec,th,dp){
    var p=num.toFixed(dec).split('.');
    p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,th);
    return p[1]?p[0]+dp+p[1]:p[0];
  }
  function money(cents,f){
    f=f||'{{amount}}';
    var m=f.match(/\{\{\s*(\w+)\s*\}\}/),k=m?m[1]:'amount',a=cents/100,v;
    if(k==='amount_no_decimals')v=group(a,0,',','.');
    else if(k==='amount_with_comma_separator')v=group(a,2,'.',',');
    else if(k==='amount_no_decimals_with_comma_separator')v=group(a,0,'.',',');
    else if(k==='amount_with_apostrophe_separator')v=group(a,2,"'",'.');
    else v=group(a,2,',','.');
    return f.replace(/\{\{\s*\w+\s*\}\}/,v);
  }
  function init(root){
    var variants={},list=[];
    try{JSON.parse(root.querySelector('[data-variants]').textContent).forEach(function(v){variants[v.id]=v;list.push(v);});}catch(e){}
    var form=root.querySelector('form.shopinza-form');
    if(!form)return;
    var fmt=root.dataset.moneyFormat;
    var input=form.querySelector('[data-variant-input]'),atc=form.querySelector('[data-atc]');
    var priceEl=root.querySelector('[data-price]'),compEl=root.querySelector('[data-compare]');
    var stockText=root.querySelector('[data-stock-text]'),stockLow=root.querySelector('[data-stock-low]');
    var threshold=parseInt(root.dataset.threshold,10)||10;
    var qtiers=root.querySelectorAll('[data-qtier]'),qty=1,disc=0;
    qtiers.forEach(function(t){
      var r=t.querySelector('input');
      if(r&&r.checked){qty=parseInt(t.dataset.qty,10)||1;disc=parseFloat(t.dataset.discount)||0;}
    });
    var slides=root.querySelectorAll('[data-slide]'),thumbs=root.querySelectorAll('[data-thumb]'),cur=0;
    function show(i){
      if(!slides.length)return;
      cur=(i+slides.length)%slides.length;
      slides.forEach(function(s,k){s.classList.toggle('is-active',k===cur);});
      thumbs.forEach(function(t,k){t.classList.toggle('is-active',k===cur);});
    }
    thumbs.forEach(function(t,k){t.addEventListener('click',function(){show(k);});});
    var nx=root.querySelector('[data-next]');
    if(nx)nx.addEventListener('click',function(){show(cur+1);});
    function shown(v){return qtiers.length?Math.round(v.price*qty*(100-disc)/100):v.price;}
    function render(id){
      var v=variants[id];if(!v)return;
      input.value=id;
      root.querySelectorAll('[data-tier]').forEach(function(t){t.classList.toggle('is-selected',t.dataset.tier==id);});
      if(priceEl)priceEl.textContent=v.priceFmt;
      if(compEl){if(v.compare>v.price){compEl.textContent=v.compareFmt;compEl.hidden=false;}else{compEl.hidden=true;}}
      qtiers.forEach(function(t){
        var q=parseInt(t.dataset.qty,10)||1,d=parseFloat(t.dataset.discount)||0;
        var tot=Math.round(v.price*q*(100-d)/100),base=(v.compare>v.price?v.compare:v.price)*q;
        t.querySelector('[data-tier-price]').textContent=money(tot,fmt);
        var c=t.querySelector('[data-tier-compare]');
        if(base>tot){c.textContent=money(base,fmt);c.hidden=false;}else{c.hidden=true;}
      });
      var label=money(shown(v),fmt);
      atc.disabled=!v.available;
      var lbl=atc.querySelector('[data-atc-label]'),pr=atc.querySelector('[data-atc-price]'),sep=atc.querySelector('[data-atc-sep]');
      if(v.available){lbl.textContent=lbl.dataset.label;pr.textContent=label;sep.hidden=false;pr.hidden=false;}
      else{lbl.textContent=lbl.dataset.soldout;sep.hidden=true;pr.hidden=true;}
      if(stockText){
        stockText.textContent=v.available?stockText.dataset.in:stockText.dataset.out;
        if(stockLow)stockLow.textContent=(v.available&&v.tracked&&v.qty>0&&v.qty<=threshold)?stockLow.dataset.tpl.replace('{n}',v.qty):'';
      }
      if(v.media>0&&v.media-1!==cur)show(v.media-1);
      try{var u=new URL(window.location.href);u.searchParams.set('variant',id);history.replaceState({},'',u);}catch(e){}
      document.dispatchEvent(new CustomEvent('shopinza:variant',{detail:{available:v.available,priceFmt:label}}));
    }
    root.querySelectorAll('[data-tier] input').forEach(function(r){r.addEventListener('change',function(){render(r.value);});});
    qtiers.forEach(function(t){
      t.querySelector('input').addEventListener('change',function(){
        qty=parseInt(t.dataset.qty,10)||1;disc=parseFloat(t.dataset.discount)||0;
        qtiers.forEach(function(x){x.classList.toggle('is-selected',x===t);});
        render(parseInt(input.value,10));
      });
    });
    var sel=[];
    root.querySelectorAll('[data-opt]').forEach(function(o,i){
      var c=o.querySelector('.shopinza-pill.is-selected');
      sel[i]=c?c.dataset.optValue:null;
      o.querySelectorAll('.shopinza-pill').forEach(function(p){
        p.addEventListener('click',function(){
          sel[i]=p.dataset.optValue;
          o.querySelectorAll('.shopinza-pill').forEach(function(q){q.classList.toggle('is-selected',q===p);});
          var cu=o.querySelector('[data-opt-current]');
          if(cu)cu.textContent=p.dataset.optValue;
          var found=null;
          list.forEach(function(v){
            if(!found&&v.options.every(function(x,k){return x===sel[k];}))found=v;
          });
          if(found)render(found.id);
        });
      });
    });
    render(parseInt(input.value,10));
    var busy=false,err=root.querySelector('[data-error]');
    function add(done){
      if(busy||atc.disabled)return;
      busy=true;err.hidden=true;
      fetch(root.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:parseInt(input.value,10),quantity:qty}]})})
        .then(function(r){if(!r.ok)throw new Error('add failed');return r.json();})
        .then(done)
        .catch(function(){busy=false;err.textContent='Sorry, we could not add this item. Please try again.';err.hidden=false;});
    }
    form.addEventListener('submit',function(e){e.preventDefault();add(function(){window.location.href=root.dataset.cartUrl;});});
    var cod=root.querySelector('[data-cod]');
    if(cod)cod.addEventListener('click',function(){add(function(){window.location.href='/checkout';});});
  }
  function boot(){
    document.querySelectorAll('[data-shopinza-pdp]').forEach(function(r){if(!r.dataset.ready){r.dataset.ready='1';init(r);}});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();